import {FlowModuleEvents, GlobalEventsMap, IEventManagerWithAsync, LogicEvents, Module, PickBonusEvents, UIDisableReason} from '@gongxigames/framework/slot';
import {PickBonusView} from 'src/pickBonus/PickBonusView';
import {GamePickBonusEvents} from 'src/pickBonus/GamePickBonusEvents';
import {GameLogic} from 'src/server/GameLogic';

export interface PickData {
    indexes: number[];
    type: number;
}

export class PickBonusModule extends Module<PickBonusView> {
    public static readonly NAME: symbol = Symbol('PickBonusModule');
    protected _isRestore = false;
    protected _items: number[] = [];

    protected setupViews(): void {
        this.setView(PickBonusView.NAME);
    }

    protected setupStates(): void {
    }

    protected setupEvents(): void {
        super.setupEvents();
        this.on(FlowModuleEvents.START_PICK_BONUS, this.onStartPickBonus);
        this.on(FlowModuleEvents.RESTORE_PICK_BONUS, this.onRestorePickBonus);
        this.on(LogicEvents.PICK_RESPONSE, this.onPickResponse);
        this.onView(PickBonusView.UPDATE_PICKED, this.onUpdatePicked);
        this.onView(PickBonusView.COIN_CLICKED, this.onCoinClicked);
        this.onView(PickBonusView.PICK_WIN_FINISHED, this.onPickBonusFinished);
    }

    protected onStartPickBonus(): void {
        const logic = this.logic as GameLogic;

        (this.eventManager as IEventManagerWithAsync<GlobalEventsMap>).emit('General.UI.DISABLE', UIDisableReason.TRIGGERING_FEATURE);

        if (logic.getWolfPickBonus() && logic.getWolfPickBonus().isBuyBonus()) {
            this.soundPlayer.play('buyBonusTrigger');
        }
        this.initItems();
        this.view.start();
        this.view.createCoins(this.itemsAmount);
        this.view.startRevealAnimation();

        if (logic.getPickedValues()) {
            logic.getPickedValues()!.forEach((data) => {
                this.view.killCoin(data[0]);
                this.view.showDiamond(data[1]);
                this._items[data[0]] = data[1];
            });
        }
    }

    protected onPickBonusFinished(): void {
        this.isRestore = false;
        this.eventManager.emit(GamePickBonusEvents.PICK_BONUS_FINISHED);
    }

    protected onRestorePickBonus(): void {
        this._isRestore = true;
        this.onStartPickBonus();
    }

    protected onPickResponse(): void {
        const values = this.logic.getPickedValues()!;

        this.pick(values[values.length - 1][0], values[values.length - 1][1]);
    }

    protected pick(index: number, value: number): void {
        (this.view as PickBonusView).pick(index, value, this.getSimilar(index, value));
    }

    protected onUpdatePicked(listenerId: string | symbol, index: number, value: number): void {
        if (this._items && this._items[index]) {
            this._items[index] = value;
        }
    }

    public initItems(): void {
        this._items = [];
        for (let i = 0; i < this.itemsAmount; i++) {
            this._items[i] = -1;
        }
    }

    protected onCoinClicked(listenerId: string | symbol, coinIndex: number): void {
        this.eventManager.emit(PickBonusEvents.PICK, coinIndex);
    }

    public getSimilar(index: number, value: number): PickData {
        const pickData = {
            indexes: [],
            type: value
        } as PickData;

        pickData.indexes.push(index);
        this._items.forEach((coinValue, coinIndex) => {
            if (coinValue === value) {
                pickData.indexes.push(coinIndex);
            }
        });

        return pickData;
    }

    public get isRestore(): boolean {
        return this._isRestore;
    }

    public set isRestore(value: boolean) {
        this._isRestore = value;
    }

    protected get itemsAmount(): number {
        return 10;
    }
}
